<template>
  <resource-box name="数据概览">
    <div slot="back">
      <div
        class="backFast"
        v-if="$store.state.chinaMap.glanceType"
        @click="backFast"
      >
        返回上级
      </div>
    </div>
    <div class="overview-container" slot="content">
      <template v-if="Statistics.length">
        <div>{{choseIndex}}</div>
        <!-- 超过6个时：轮播展示（每组6个，2行3列） -->
        <el-carousel
          trigger="click"
          v-if="Statistics.length >= 6"
          indicator-position="outside"
          :autoplay="true"
          class="overview-carousel"
        >
          <el-carousel-item
            v-for="(group, groupIndex) in groupedStatistics"
            :key="groupIndex"
          >
            <!-- 2行3列布局容器 -->
            <div class="overview-grid" :class="choseIndex ? 'choseStyle' : ''">
              <div
                v-for="(item, index) in group"
                :key="index"
                v-show="item.isShow"
                @click="typeBtn(item)"
                class="overview-item"
              >
                <div class="overview_imgs">
                  <img class="overview_imgs_icon" :src="item.imgurl" alt="" />
                  <img :src="FrameBtn" alt="" />
                </div>
                <div class="overview_content">
                  <!-- 公司名称过长：省略+Tooltip -->
                  <el-tooltip
                    :content="item.companyName"
                    placement="bottom"
                    effect="dark"
                  >
                    <div class="overview_content_name">
                      {{ item.companyName }}
                    </div>
                  </el-tooltip>
                  <div class="overview_content_nums">
                    {{ item.count || 0 }}<span>个</span>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- 小于等于6个时：直接2行3列展示，无轮播 -->
        <div
          v-else
          class="overview-grid"
          :class="choseIndex ? 'choseStyle' : ''"
        >
          <div
            v-for="(item, index) in Statistics"
            :key="index"
            v-show="item.isShow"
            @click="typeBtn(item)"
            class="overview-item"
          >
            <div class="overview_imgs">
              <div class="overview_imgs">
                <img class="overview_imgs_icon" :src="item.imgurl" alt="" />
                <img :src="FrameBtn" alt="" />
              </div>
            </div>
            <div class="overview_content">
              <el-tooltip
                :content="item.companyName"
                placement="bottom"
                effect="dark"
              >
                <div class="overview_content_name">{{ item.companyName }}</div>
              </el-tooltip>
              <div class="overview_content_nums">
                {{ item.count || 0 }}<span>个</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <el-empty
          :image="require('@/assets/recycling/index/empty.svg')"
          description="暂无数据"
          style="height: inherit;width: 100%"
          v-else
      />
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
import { getOverViewName } from '@/API/echarts/echarts';
import { getAreaCount } from '@/API/chinaMapApi/chinaMapApi';

export default {
  name: 'dataOverview',
  components: {
    resourceBox,
  },
  data() {
    return {
      choseIndex: false,
      Statistics: [],
      OriginalData: [],
      FrameBtn: require('@/assets/recycling/chinaMap/companyBase.svg'),
      FrameIcon: require('@/assets/recycling/chinaMap/companys.svg'),
    };
  },
  watch: {
    // 区域发生变化，统计数量同步更新
    '$store.state.chinaMap.currentlyMapAdcode': {
      handler: function () {
        this.getStatistics();
      },
    },
  },
  computed: {
    // 按每组6个拆分数据（2行3列=6个，适配轮播）
    groupedStatistics() {
      const groups = [];
      const chunkSize = 6; // 每组固定6个（2行3列）
      for (let i = 0; i < this.Statistics.length; i += chunkSize) {
        groups.push(this.Statistics.slice(i, i + chunkSize));
      }
      return groups;
    },
  },
  mounted() {
    this.getStatistics();
  },
  methods: {
    getStatistics() {
      let params = {
        region: this.$store.state.chinaMap.currentlyMapAdcode,
        types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
      };
      this.Statistics = [];
      getAreaCount(params).then((res) => {
        if (res.code === 200) {
          this.$set(
            this,
            'OriginalData',
            res.data.map((item) => ({
              ...item,
              isShow: true,
              imgurl: item.imgurl
                ? window.location.origin + '/apisix' + item.imgurl
                : this.FrameIcon,
            })),
          );

          this.Statistics =this.OriginalData.filter(item=>{
            return item.count
          });
        }
      });
    },
    typeBtn(value) {
      this.choseIndex = true;
      if (this.$store.state.chinaMap.Maplevel > 2) return;
      this.Statistics = [value];
      this.$store.commit('chinaMap/changeCompanyId', value.companyId);
      // this.$store.commit('chinaMap/changeLowerLevelData', value);
      this.$store.commit('chinaMap/changeGlanceType', value);
    },
    backFast() {
      this.choseIndex = false;
      this.Statistics = [...this.OriginalData];
      this.$store.commit('chinaMap/changeGlanceType', undefined);
      this.$store.commit('chinaMap/changeCompanyId', undefined);
    },
  },
};
</script>

<style lang="less" scoped>
.backFast {
  cursor: pointer;
  padding: 0px 10px;
  line-height: 35px;
  color: #ffffff;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  border: 1px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
}
.overview-container {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.overview-carousel {
  width: 100%;
  height: 100%;

  ::v-deep .el-carousel__arrow {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 153, 102, 0.8);
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    &:hover {
      background: rgba(0, 204, 136, 1);
    }

    i {
      color: #fff;
      font-size: 18px;
    }
  }

  ::v-deep .el-carousel__arrow--left {
    left: 10px;
  }

  ::v-deep .el-carousel__arrow--right {
    right: 10px;
  }

  ::v-deep .el-carousel__item {
    height: 100%;
    background: transparent;
    border: none;
  }
}

.overview-grid {
  display: flex;
  flex-direction: row; // 水平方向排列（从左到右）
  flex-wrap: wrap; // 换行（每行 3 个，第 4 个换到下一行）
  justify-content: flex-start; // 左对齐
  align-content: flex-start; // 顶部对齐
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  gap: 8px 0; // 行间距
}

.overview_content {
  margin-top: 10px;
}
.overview-item {
  flex: 0 0 calc(100% / 3); // 宽度=容器 1/3（一行 3 个）
  height: calc(100% / 2); // 高度=容器 1/2（两行占满）
  box-sizing: border-box;
  padding: 0 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center; // 内部元素垂直居中
  align-items: center; // 内部元素水平居中
}

.overview_content_name {
  font-size: 12px;
  color: #ffffff;
  width: 130px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.overview_content_nums {
  font-size: 18px;
  color: rgba(47, 241, 255, 1);
  font-weight: 500;
  text-align: center;
  span {
    font-size: 10px;
    margin-left: 2px;
  }
}
.overview_imgs {
  position: relative;
  padding-top: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .overview_imgs_icon {
    position: absolute;
    left: 50%;
    bottom: 60%;
    max-height: 40px;
    max-width: 40px;
    transform: translate(-50%, 50%); // 精准居中
    animation: bounce 2s infinite;
  }

  // 修复多个图标错位问题
  .overview_imgs_icon:last-child {
    left: 50%;
    transform: translate(-50%, 50%);
  }
}
.choseStyle {
  justify-content: center !important;
  align-items: center !important;
  align-content: center;
}
</style>
